<template>
  <div class="motor-logbook-fields">
    <div class="form-row">
      <div class="input-group">
        <label class="input-label">Logbook number <span class="req">*</span></label>
        <v-text-field
          :value="logBookNumber"
          placeholder="e.g. K1234567A"
          outlined
          dense
          hide-details="auto"
          maxlength="10"
          class="custom-input"
          :rules="logbookRules"
          @input="$emit('update:logBookNumber', $event)"
          @blur="$emit('update:logBookNumber', sanitizeLogbook(logBookNumber))"
        />
      </div>
      <div class="input-group">
        <label class="input-label">Logbook transferred? <span class="req">*</span></label>
        <div class="logbook-transfer-toggle">
          <label :class="['lbt-option', transferred === 'yes' ? 'lbt-yes' : '']">
            <input type="radio" value="yes" :checked="transferred === 'yes'" class="tw-hidden" @change="$emit('update:transferred', 'yes')" />
            <v-icon x-small :color="transferred === 'yes' ? '#059669' : '#94a3b8'" class="tw-mr-1">mdi-check-circle</v-icon>
            Yes, transferred
          </label>
          <label :class="['lbt-option', transferred === 'no' ? 'lbt-no' : '']">
            <input type="radio" value="no" :checked="transferred === 'no'" class="tw-hidden" @change="$emit('update:transferred', 'no')" />
            <v-icon x-small :color="transferred === 'no' ? '#F59E0B' : '#94a3b8'" class="tw-mr-1">mdi-alert-circle-outline</v-icon>
            Not yet
          </label>
        </div>
      </div>
    </div>
    <div v-if="transferred === 'no'" class="lbt-warning">
      <v-icon x-small color="#D97706" class="tw-mr-1">mdi-information-outline</v-icon>
      Note: The logbook must be transferred to the insured.
    </div>
  </div>
</template>

<script>
import { sanitizeLogbook } from '@/utils/sanitize';
import { motorLogbookNoRules } from '@/utils/motorVehicleValidation';

export default {
  name: 'MotorLogbookFields',
  props: {
    logBookNumber: { type: String, default: '' },
    transferred: { type: String, default: 'yes' },
  },
  computed: {
    logbookRules() {
      return motorLogbookNoRules;
    },
  },
  methods: { sanitizeLogbook },
};
</script>

<style scoped lang="scss">
@import '@/styles/motor-sale-shared.scss';
</style>
